import { http } from './http'
import { Pagination, PaginationParams } from './map'
import { Assets } from '../../common/models'

interface UploadResponse {
  fileKey: string
  fileUrl: string
}

export const getAssets = (params?: PaginationParams) =>
  http.get<Pagination<Assets>>(`/operations/assets`, {
    params,
  })

export const deleteAssets = (ids: string[]) =>
  http.delete(`/operations/assets`, {
    data: {
      ids,
    },
  })

export const saveAssets = (keys: string[]) =>
  http.post(`/operations/assets`, {
    assetsKeys: keys,
  })

export const uploadAsset = async (file: File) => {
  const formData = new FormData()
  formData.append('file', file)
  return http.post<UploadResponse>(`/operations/assets/upload`, formData)
}
